import React from 'react';
import { observer } from 'mobx-react';
import { Modal, Button, Header } from 'semantic-ui-react';
import LoomEmbed from './LoomEmbed';
import { PLAN_PHASES, PLAN_LENGTH_DAYS } from './trainingPlan';

const FONT = { fontFamily: 'Montserrat' };

// First-login welcome. Purely presentational — DashboardPage owns the open
// latch, the welcome-seen PATCH, and the slot launchers. The intro Loom is
// per-company (company.trainingPlanVideos.intro) and simply absent for
// companies without one.
const WelcomeModal = observer(({ open, onClose, currentUser, company, planState, onStartNext, onShowMeAround }) => {
  if (!open) return null;

  const firstName = currentUser?.firstName || 'there';
  const assigned = !!planState?.assigned;
  const returning = (planState?.completedBeforeToday || 0) > 0 || (planState?.practiceCount || 0) > 0;
  const intro = company?.trainingPlanVideos?.intro;
  const next = planState?.nextSlot;

  return (
    <Modal open={open} onClose={onClose} size="small" closeIcon>
      <Header
        icon="graduation cap"
        content={assigned || returning ? `Welcome back, ${firstName}` : `Welcome to Multiply, ${firstName}`}
        style={FONT}
      />
      <Modal.Content>
        {intro?.loomId && (
          <LoomEmbed loomId={intro.loomId} title={intro.title || `How ${company?.name || 'your team'} uses Multiply`} />
        )}
        <p style={{ ...FONT, fontSize: '14px', color: '#444', marginBottom: '14px' }}>
          {assigned
            ? `Your Training Plan has been restarted. Consider it a refresher: about 15 to 20 minutes a day for ${PLAN_LENGTH_DAYS} practice days, and it tells you exactly what to practice each time you log in.`
            : `Murphy has a ${PLAN_LENGTH_DAYS}-day Training Plan for you: about 15 to 20 minutes a day, and it tells you exactly what to practice each time you log in.`}
        </p>
        <div style={{ marginBottom: '6px' }}>
          {PLAN_PHASES.map((phase) => (
            <div key={phase.label} style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
              <div style={{ ...FONT, fontSize: '13px', fontWeight: 700, color: '#0784a7', minWidth: '72px' }}>
                {phase.label}
              </div>
              <div style={{ ...FONT, fontSize: '13px', color: '#555', flex: 1 }}>{phase.summary}</div>
            </div>
          ))}
        </div>
      </Modal.Content>
      <Modal.Actions style={{ display: 'flex', alignItems: 'center' }}>
        <button
          type="button"
          onClick={onShowMeAround}
          style={{ ...FONT, background: 'none', border: 'none', color: '#0784a7', cursor: 'pointer', fontSize: '13px', textDecoration: 'underline', padding: 0 }}
        >
          Show me around first
        </button>
        <div style={{ flex: 1 }} />
        <Button onClick={onClose} style={FONT}>
          I'll explore on my own
        </Button>
        {next && (
          <Button
            primary
            onClick={() => onStartNext(next)}
            style={{ ...FONT, backgroundColor: '#137fa2' }}
          >
            Start Day {planState.currentDayNumber}: {next.slot.title}
            {next.slot.estimatedMinutes ? ` (~${next.slot.estimatedMinutes} min)` : ''}
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  );
});

export default WelcomeModal;
